import type { ThemeContract } from "./contract";

type FlatCssVariables = Record<string, string>;

function flatten(input: unknown, prefix = "", output: FlatCssVariables = {}): FlatCssVariables {
  if (typeof input === "string" || typeof input === "number") {
    output[`--${prefix}`] = String(input);
    return output;
  }

  if (input && typeof input === "object") {
    Object.entries(input as Record<string, unknown>).forEach(([key, value]) => {
      if (key === "name") return;
      const cssKey = prefix ? `${prefix}-${key}` : key;
      flatten(value, cssKey, output);
    });
  }

  return output;
}

export function generateCssVariables(theme: ThemeContract): FlatCssVariables {
  return flatten(theme);
}
